import React from "react";
import { Character } from "../../../types";
import CharacterInputField from "./CharacterInputField";
import { Label } from "@/components/ui/label";

interface CharacterSubmitBaseProps {
  characters: Character[];
  characterNames: Map<number, string>;
  characterMaturities: Map<number, boolean>;
  showCharacterMaturity: boolean;
  onNameChange: (event: React.ChangeEvent<HTMLInputElement>) => string;
  onMatureChange: (
    characterId: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
}

const CharacterSubmitBase: React.FunctionComponent<
  CharacterSubmitBaseProps
> = ({
  characters,
  characterNames,
  characterMaturities,
  showCharacterMaturity,
  onNameChange,
  onMatureChange,
}) => {
  return (
    <div className="flex-1 flex flex-col flex-nowrap justify-evenly items-center space-y-2 my-2">
      {characters?.map((v, idx) => (
            <div
              key={`char-${v.id}`}
              className={"flex flex-col mx-1 space-y-1 max-w-full"}
            >
              <CharacterInputField
                character={v}
                index={idx}
                value={characterNames.get(v.id) ?? ""}
                onNameChange={onNameChange}
                className="px-4"
              />
              {showCharacterMaturity && (
                <div className="flex flex-row items-center justify-end mt-2">
                  <div className="leading-none flex flex-row items-center rounded-none  overflow-hidden space-x-2 ">
                    <div className="flex items-center">
                      <input
                        id={`mature-yes-${v.id}`}
                        name={`mature-${v.id}`}
                        type="radio"
                        value="true"
                        onChange={(e) => onMatureChange(v.id, e)}
                        checked={characterMaturities.get(v.id) === true}
                        className="sr-only"
                      />
                      <Label
                        className={`px-1 text-lg  cursor-pointer ${
                          characterMaturities.get(v.id) === true
                            ? "bg-gray-drk border-4 border-gray-drker"
                            : "bg-gray-light border border-black"
                        }`}
                        htmlFor={`mature-yes-${v.id}`}
                      >
                        18+
                      </Label>
                    </div>
                    <div className="flex items-center">
                      <input
                        id={`mature-no-${v.id}`}
                        name={`mature-${v.id}`}
                        type="radio"
                        value="false"
                        onChange={(e) => onMatureChange(v.id, e)}
                        checked={characterMaturities.get(v.id) === false}
                        className="sr-only"
                      />
                      <Label
                        className={`px-1 text-lg cursor-pointer ${
                          characterMaturities.get(v.id) === false
                            ? "bg-gray-drk border-4 border-gray-drker"
                            : "bg-gray-light border border-black"
                        }`}
                        htmlFor={`mature-no-${v.id}`}
                      >
                        all ages
                      </Label>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
    </div>
  );
};

export default CharacterSubmitBase;
